<template>
    <v-container ref="pageActions" fluid tag="section">

        <material-card icon="mdi-clipboard-text" icon-small title="Перевірка категорії ST" color="accent" class="mb-16">
            <!--Фильтры-->
            <v-row class="mx-2 mb-2">
                <v-col cols="12" md="3">
                    <v-select return-object item-text="name" item-value="name" v-model="project" :items="projects"
                        label="Проект" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-col>
            </v-row>

            <!--Таблица-->
            <v-data-table :headers="categoriesStHeaders" :items="categories_st" class="elevation-1" :search="search"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100, -1] }" :options="{ itemsPerPage }">
                <template v-slot:top>
                </template>
            </v-data-table>
            <!--Диалоговое окно для удаления-->
            <DialogConfitmDelete ref="dialogConfirmDelete" />
            <Preloader v-if="isSending" />
        </material-card>
    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'RegularTablesView',
    data() {
        return {
            // Тецущий проект
            project: {},
            // Типы акций
            mis: null,
            // Текущая страница
            pageCurrent: null,
            // Количество элементов на странице
            itemsPerPage: 50,
            // Количество страниц
            pagesCount: 1,
            // Выполняется отправка на сервер
            isSending: false,
            categoriesStHeaders: [
                { text: 'ID', value: 'id' },
                { text: 'Назва', value: 'name' },
                { text: 'Знаходиться', value: 'path' },
                { text: 'Проект', value: 'project_name' },
                { text: 'Назва категорії adminpanel', value: 'category_name', },
                { text: 'Повний шлях по каталогу adminpanel', value: 'category_path', },

            ],
            categories_st: [],
            search: '',
        }
    },
    computed: {
        ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
        this.init();
    },

    watch: {
        // Сделано через watch  чтобы отслеживать переходы вне страницы (например если пользователь нажмёт в меню /actions/)
        '$route': {
            handler() {
                this.getActions();
            },
            deep: true,
        }
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getProjects']),

        async init() {
            await this.getProjects();
            await this.getCategoriesSt();

        },
        async getCategoriesSt() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-categories-st-list', {
                    project_id: this.project.id
                });
                this.categories_st = data.content;
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        setQueryParam() {
            this.getCategoriesSt();
        },

    },
}

</script>

<style>
.add-user__button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
